import type { TOC } from '@ember/component/template-only';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';
import type { KioskDemoPage } from 'garaje/components/homepage/kiosk-demo/provider';

interface VisitorsRecognitionPageSignature {
  Args: KioskDemoPage;
}

export default <template>
  <PageTemplate
    @headerTitle="Choose sign-in flow"
    @headerInfo="If you have multiple sign-in flows, visitors will choose among them."
    @currentStep={{@currentStep}}
    @totalStepCount={{@totalStepCount}}
    @demoName={{@demoName}}
    @isUserLoggedIn={{@isUserLoggedIn}}
    @isDemoInstance={{@isDemoInstance}}
  >
    <div>
      <ActionItemTemplate
        @header="Add multiple sign-in flows"
        @headerInfo="Add more sign-in flows, and customize the questions for each flow."
        @subHeader="Required plan: Premium"
        @iconLink="/assets/images/ipad-demo/icons/girl.svg"
        @iconAlt="Image of sign in flow"
        @pageLink="/visitors/settings/visitor-types"
        @isUserLoggedIn={{@isUserLoggedIn}}
        @demoName={{@demoName}}
        @isDemoInstance={{@isDemoInstance}}
      />
    </div>
  </PageTemplate>
</template> satisfies TOC<VisitorsRecognitionPageSignature>;
